export default __webpack_public_path__ + "static/media/lightOff.9c7550c6.svg";